import React from "react";
import { Tag, Typography } from "antd";

const { Title } = Typography;

const portData = {
  "North America": [
    "Baltimore, Maryland",
    "Boston, Massachusetts",
    "Cape Liberty (New York), New Jersey",
    "Fort Lauderdale, Florida",
    "Galveston, Texas",
    "Los Angeles, California",
    "Miami, Florida",
    "New Orleans, Louisiana",
    "Oahu (Honolulu), Hawaii",
    "Orlando (Port Canaveral), Florida",
    "San Diego, California",
    "Seattle, Washington",
    "Seward, Alaska",
    "Tampa, Florida",
    "Vancouver, British Columbia",
  ],
  Europe: [
    "Athens (Piraeus), Greece",
    "Barcelona, Spain",
    "Ravenna (Venice), Italy",
    "Rome (Civitavecchia), Italy",
    "Southampton, England",
  ],
  Australia: [
    "Brisbane, Australia",
    "Sydney, Australia",
  ],
};

const disabledPorts = [
  "San Diego, California",
  "Seattle, Washington",
  "Seward, Alaska",
  "Vancouver, British Columbia",
  "Ravenna (Venice), Italy",
  "Brisbane, Australia",
];

const DeparturePortFilter = ({ value = [], onChange }) => {
  const selectedPorts = value;

  const handleToggle = (port) => {
    if (disabledPorts.includes(port)) return;

    const isSelected = selectedPorts.includes(port);
    const newSelection = isSelected
      ? selectedPorts.filter((p) => p !== port)
      : [...selectedPorts, port];
 
    onChange?.(newSelection);
  };

  return (
    <div className="space-y-8">
      {Object.entries(portData).map(([region, ports]) => (
        <div key={region}>
          <Title level={5} className="text-[#1a1a1a] font-semibold mb-4">
            {region}
          </Title>
          <div className="flex flex-wrap gap-3">
            {ports.map((port) => {
              const isSelected = selectedPorts.includes(port);
              const isDisabled = disabledPorts.includes(port);

              return (
                <Tag
                  key={port}
                  className={`rounded-full px-4 py-2 text-sm cursor-pointer transition-all ${
                    isDisabled
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : isSelected
                      ? "bg-[#1a3aff] text-white border-none"
                      : "border border-[#1a3aff] text-[#1a3aff] hover:bg-[#e6ecff]"
                  }`}
                  onClick={() => handleToggle(port)}
                >
                  {port}
                </Tag>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DeparturePortFilter;
